import { RouterProvider, createRouter } from "@tanstack/react-router";
// import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { authAdapter } from "@/core/auth/adapter";
import { SplashScreen } from "@/core/components/SplashScreen.tsx";
import { ThemeProvider, Toaster } from "@k3-tech/react-kit";
import { AuthProvider } from "@k3-tech/react-kit";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles.css";
import "@k3-tech/react-kit/kit/themes/base.css";
import "@k3-tech/react-kit/kit/themes/default.css";
import UrqlProvider from "./providers/UrqlProvider.tsx";
import reportWebVitals from "./reportWebVitals.ts";

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: { authAdapter },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    // <StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="k3-theme">
      <AuthProvider adapter={authAdapter} autoSync>
        <UrqlProvider>
          <SplashScreen>
            <RouterProvider router={router} />
          </SplashScreen>
          <Toaster />
        </UrqlProvider>
      </AuthProvider>
    </ThemeProvider>
    // </StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
